/* tslint:disable */
/* eslint-disable */
/**
 * MinSide.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { UserMigrationStatus } from './UserMigrationStatus';
import {
    UserMigrationStatusFromJSON,
    UserMigrationStatusFromJSONTyped,
    UserMigrationStatusToJSON,
    UserMigrationStatusToJSONTyped,
} from './UserMigrationStatus';

/**
 * 
 * @export
 * @interface UserMigrationStatusUpdateRequest
 */
export interface UserMigrationStatusUpdateRequest {
    /**
     * 
     * @type {UserMigrationStatus}
     * @memberof UserMigrationStatusUpdateRequest
     */
    migrationStatus?: UserMigrationStatus;
}



/**
 * Check if a given object implements the UserMigrationStatusUpdateRequest interface.
 */
export function instanceOfUserMigrationStatusUpdateRequest(value: object): value is UserMigrationStatusUpdateRequest {
    return true;
}

export function UserMigrationStatusUpdateRequestFromJSON(json: any): UserMigrationStatusUpdateRequest {
    return UserMigrationStatusUpdateRequestFromJSONTyped(json, false);
}

export function UserMigrationStatusUpdateRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserMigrationStatusUpdateRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'migrationStatus': json['migrationStatus'] == null ? undefined : UserMigrationStatusFromJSON(json['migrationStatus']),
    };
}

export function UserMigrationStatusUpdateRequestToJSON(json: any): UserMigrationStatusUpdateRequest {
    return UserMigrationStatusUpdateRequestToJSONTyped(json, false);
}

export function UserMigrationStatusUpdateRequestToJSONTyped(value?: UserMigrationStatusUpdateRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'migrationStatus': UserMigrationStatusToJSON(value['migrationStatus']),
    };
}

